<template>
  <div class="baskets-right-panel">
    <div class="baskets-right">
      <div class="basket-right" v-for="b in basket.baskets">
        <div v-for="position in b.positions" class="basket-right-position">
          <div class="basket-right-photo">
            <img
              v-if="position.photo_url == '/nophoto.png'"
              src="//cdn01.redbay.pl/layouts/boma/img/noimg.jpg"
              alt="brak zdjęcia"
              class="img-fluid"
            />
            <img v-else :src="getPhoto(position)" :alt="position.name" class="img-fluid" />
          </div>
          <div class="position-right-name">
            <router-link
              :to="{ name: 'productPage', params:{id: position.product_id, slug: 'item'}}"
            >{{position.name}}</router-link>
          </div>
          <div class="position-right-name">
            <span>Jednostka: {{position.unit_name}}</span>
          </div>
          <!--<div class="position-right-name">{{position.name}}</div>-->
          <div class="position-right-values">
            <div class="position-right-quantity">
              <span class="minus" @click="subQuantity(position)"></span>
              <span class="quantity">{{position.cart_quantity}}</span>
              <span class="plus" @click="addQuantity(position)"></span>
            </div>
            <div class="position-right-price-net">
              <span>netto</span>
              {{priceToString(position.price_net * position.cart_quantity, currency().currency.symbol)}}
            </div>
            <div class="position-right-price-gross">
              <span>brutto</span>
              {{priceToString(position.price_gross * position.cart_quantity, currency().currency.symbol)}}
            </div>
          </div>

          <div v-if="position.range" class="basket-gratis-info">
            <div
              v-if="position.cart_quantity < position.range.min_quantity"
              class="alert alert-info mb-0 p-1"
            >
              Kup jeszcze {{quantityToGratis(position.range.min_quantity, position.cart_quantity)}}
              <!-- <span>{{quantityToGratisLabel(position.range.min_quantity, position.cart_quantity)}}</span> -->
              <span
                v-if="quantityToGratis(position.range.min_quantity, position.cart_quantity) === 1"
              >sztukę</span>
              <span
                v-else-if="quantityToGratis(position.range.min_quantity, position.cart_quantity) >= 2 && quantityToGratis(position.range.min_quantity, position.cart_quantity) <= 4"
              >sztuki</span>
              <span v-else>sztuk</span>
              tego produktu, a otrzymasz
              <span
                class="basket-gratis-product"
              >{{ position.range.product_name }}</span>
            </div>
            <div v-else class="alert alert-success mb-0 p-1">
              Otrzymujesz
              <span class="basket-gratis-product">{{ position.range.product_name }}!</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="baskets-right-bottom">
      <div class="baskets-right-bottom-message">Razem</div>
      <div class="baskets-right-bottom-prices">
        <div class="price-net">
          <span>netto</span>
          {{priceToString(sumNet(), currency().currency.symbol)}}
        </div>
        <div class="price-gross">
          <span>brutto</span>
          {{priceToString(sumGross(), currency().currency.symbol)}}
        </div>

        <div class="baskets-button" @click="gotoBasket()">
          Szczegóły koszyka
          <cart-icon title="Szczegóły koszyka"></cart-icon>
        </div>
        <div class="order-button" @click="gotoOrder()">
          Przejdź do zamówienia
          <cart-icon title="Przejdź do zamówienia"></cart-icon>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import CalculatePrice from "../../products/src/product/CalculatePrice";
import Cms from "../../cms/src/Cms";
import CartIcon from "vue-material-design-icons/Cart.vue";

export default {
  components: { CartIcon },

  computed: {
    ...mapState({
      basket: state => state.basket.basket,
      shop: state => state.shop.settings,
      demo: state => state.demo.enabled
    }),
    ...mapGetters({
      currency: "company/selectedCurrency"
    })
  },
  data() {
    return {
      units: { single: [], decimals: [] },
      purchaseOverbookedProducts: false
    };
  },
  methods: {
    ...CalculatePrice(),

    quantityToGratis(range, basket) {
      return range - basket;
    },

    getPhoto(position) {
      return Cms.replaceSizePhoto(position.photo_url, 100, 125);
    },

    gotoBasket() {
      this.$router.replace({ name: "cart" });
    },

    gotoOrder() {
      this.$router.replace({ name: "orderForm" });
    },

    sumNet() {
      if (this.basket.baskets.length > 0) {
        return this.basket.baskets
          .map(b => b.price_net)
          .reduce((a, b) => a + b);
      }
      return 0;
    },

    sumGross() {
      if (this.basket.baskets.length > 0) {
        return this.basket.baskets
          .map(b => b.price_gross)
          .reduce((a, b) => a + b);
      }
      return 0;
    },

    subQuantity(position) {
      if (position.cart_quantity > 0) {
        if (this.units.single.indexOf(position.unit_name) > 0) {
          position.cart_quantity--;
        }
        if (this.units.decimals.indexOf(position.unit_name) > 0) {
          position.cart_quantity =
            Math.round((position.cart_quantity - 0.001) * 1000) / 1000;
        } else {
          position.cart_quantity--;
        }
        this.modify(position);
      }
    },

    addQuantity(position) {
      if (
        position.cart_quantity < position.quantity ||
        this.purchaseOverbookedProducts
      ) {
        if (this.units.single.indexOf(position.unit_name) > 0) {
          position.cart_quantity++;
        }
        if (this.units.decimals.indexOf(position.unit_name) > 0) {
          position.cart_quantity =
            Math.round((position.cart_quantity + 0.001) * 1000) / 1000;
        } else {
          position.cart_quantity++;
        }
        this.modify(position);
      }
    },

    remove(position) {
      this.$store.dispatch("basket/removePosition", position);
    },

    modify(position) {
      this.$store.dispatch("basket/modifyPosition", position);
    },

    orderForm() {
      this.$router.replace({ name: "orderForm" });
    }
  },

  beforeMount() {
    if (!this.demo) {
      this.units = this.$config.get("basket.units");
      this.$store.dispatch("basket/data");
      let b2bOverbooking = this.shop.find(s => s.name == "B2B_OVERBOOKING");
      this.purchaseOverbookedProducts =
        b2bOverbooking && b2bOverbooking.value == 1;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/basket/src/BasketRight.vue